import React from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import useAxios from '../hooks/useAxios';
import { toaster } from '../utils/toast';
import LoggedInUserService from '../services/AuthService';
import XButton from '../components/common/XButton';
import XLink from '../components/common/XLink';
import XLoaderWithoutStyle from '../components/common/XLoaderWithoutStyle';
import {
    inputFieldClasses,
    inputFieldStyleClasses,
    labelStyleClasses,
    errorMessageClasses,
} from '../components/common/formInputClasses';


const LoginForm = ({ apiUrl, redirectPath }) => {
    const { isLoading, postData } = useAxios();
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        email: Yup.string().required('Email is required').email('Please enter a valid email'),
        password: Yup.string().required('Password is required').min(8, 'Password must be at least 8 characters long'),
    });
    return (
        <>
            <h3 className="font-['Open_Sans',serif]! text-content mb-6!">
                Login
            </h3>
            <Formik 
                initialValues= {{
                    email: '',
                    password: '',
                }}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                    const { success, data, message } = await postData(apiUrl, values);
                    if (success) {
                        const { token } = data;
                        LoggedInUserService.UpdateLoggedInUserSession(token);
                        navigate(redirectPath);
                    } else {
                        toaster({ message, success });
                    }
            }}>
                <Form>
                    <div className="fields">
                        <div className="form-group">
                            <label className={labelStyleClasses}>Email</label>
                            <div className={inputFieldClasses}>
                                <Field className={inputFieldStyleClasses} type="text" name="email" placeholder="Email" />
                                <ErrorMessage name="email" component="div" className={errorMessageClasses} />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className={labelStyleClasses}>Password</label>
                            <div className={inputFieldClasses}>
                                <Field className={inputFieldStyleClasses} type="password" name="password" placeholder="Password" />
                                <ErrorMessage name="password" component="div" className={errorMessageClasses} />
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-between items-center'>
                        <XLink to="/account/forgot-password">Forgot Password?</XLink>
                        <XButton loading={isLoading} type="submit" buttonText="Login" />
                    </div>
                    {isLoading && <XLoaderWithoutStyle />}
                </Form>
            </Formik>
        
        </>
    );
};

export default LoginForm;
